module.exports = __webpack_public_path__ + "static/img/touxi2.f96c3f35.webp";